"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _LanguageGlobe = _interopRequireDefault(require("@insided/shared/icons/LanguageGlobe"));

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

var _ChevronUp = _interopRequireDefault(require("@insided/shared/icons/ChevronUp"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function sortLanguagesAlphabetically(languages) {
  var languagesToSort = (0, _toConsumableArray2.default)(languages);
  return languagesToSort.sort(function (languageA, languageB) {
    return languageA.name < languageB.name ? -1 : 1;
  });
}

var LanguageSwitcher = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LanguageSwitcher, _Component);

  var _super = _createSuper(LanguageSwitcher);

  function LanguageSwitcher() {
    var _this;

    (0, _classCallCheck2.default)(this, LanguageSwitcher);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isDropdownOpen: false,
      isPublishedLanguagesGroupOpen: true,
      isUnpublishedLanguagesGroupOpen: true
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderLanguageSwitcherDropdownItem", function (language) {
      var showDefaultIndicator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var selectedLanguageCode = _this.props.selectedLanguageCode;
      return (0, _preact.h)("button", {
        className: (0, _classnames.default)('community-language-switcher_dropdown_item', {
          'community-language-switcher_dropdown_item--selected': language.code === selectedLanguageCode
        }),
        onClick: function onClick() {
          return _this.onLanguageSelected(language);
        },
        key: language.code,
        "data-value": language.code,
        "data-qa": language.name,
        "aria-label": language.name
      }, (0, _preact.h)("span", null, language.name), showDefaultIndicator && language.isDefault && (0, _preact.h)("span", {
        className: "community-language-switcher_dropdown_item-default"
      }, "Default"));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderLanguageSwitcherDropdownGroup", function (groupName, languages, isOpen, onToggle) {
      var sortedLanguages = sortLanguagesAlphabetically(languages);
      if (sortedLanguages.length === 0) return null;
      return (0, _preact.h)("div", {
        className: "community-language-switcher_dropdown_group",
        "data-group": groupName.toLowerCase().replace(/\s+/g, '-')
      }, (0, _preact.h)("button", {
        className: "community-language-switcher_dropdown_group-name",
        onClick: onToggle
      }, groupName, isOpen ? (0, _preact.h)(_ChevronUp.default, null) : (0, _preact.h)(_ChevronDown.default, null)), isOpen && sortedLanguages.map(function (language) {
        return _this.renderLanguageSwitcherDropdownItem(language, true);
      }));
    });
    return _this;
  }

  (0, _createClass2.default)(LanguageSwitcher, [{
    key: "toggleDropdown",
    value: function toggleDropdown() {
      var isDropdownOpen = this.state.isDropdownOpen;
      this.setState({
        isDropdownOpen: !isDropdownOpen
      });
    }
  }, {
    key: "closeDropdown",
    value: function closeDropdown() {
      this.setState({
        isDropdownOpen: false
      });
    }
  }, {
    key: "onLanguageSelected",
    value: function onLanguageSelected(language) {
      var onLanguageChanged = this.props.onLanguageChanged;
      this.closeDropdown();
      onLanguageChanged === null || onLanguageChanged === void 0 ? void 0 : onLanguageChanged(language.code);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          languages = _this$props.languages,
          _this$props$userRoles = _this$props.userRoles,
          userRoles = _this$props$userRoles === void 0 ? [] : _this$props$userRoles,
          _this$props$allowedUs = _this$props.allowedUserRoles,
          allowedUserRoles = _this$props$allowedUs === void 0 ? [] : _this$props$allowedUs,
          _this$props$published = _this$props.publishedLanguages,
          publishedLanguages = _this$props$published === void 0 ? [] : _this$props$published,
          _this$props$enabledLa = _this$props.enabledLanguages,
          enabledLanguages = _this$props$enabledLa === void 0 ? [] : _this$props$enabledLa,
          isControl = _this$props.isControl,
          customTrigger = _this$props.customTrigger;
      var _this$state = this.state,
          isDropdownOpen = _this$state.isDropdownOpen,
          isPublishedLanguagesGroupOpen = _this$state.isPublishedLanguagesGroupOpen,
          isUnpublishedLanguagesGroupOpen = _this$state.isUnpublishedLanguagesGroupOpen;
      var isAdmin = isControl !== null && isControl !== void 0 ? isControl : userRoles.some(function (role) {
        return allowedUserRoles.includes(role);
      });
      var languageOptions = sortLanguagesAlphabetically(languages !== null && languages !== void 0 ? languages : []);
      var languagesCount = enabledLanguages.length + publishedLanguages.length;
      var shouldRender = isAdmin ? languagesCount > 1 : languageOptions.length > 1;
      if (!shouldRender) return null;
      return (0, _preact.h)("div", {
        className: "community-language-switcher"
      }, (0, _preact.h)("div", {
        className: "community-language-switcher_wrapper"
      }, (0, _preact.h)("button", {
        className: "community-language-switcher_trigger-button",
        onClick: function onClick() {
          return _this2.toggleDropdown();
        },
        onKeyDown: function onKeyDown(event) {
          if (event.key === 'Enter') {
            _this2.toggleDropdown();
          }
        }
      }, customTrigger !== null && customTrigger !== void 0 ? customTrigger : (0, _preact.h)("div", {
        className: "community-language-switcher_trigger"
      }, (0, _preact.h)(_LanguageGlobe.default, {
        height: 16,
        width: 16
      }))), isDropdownOpen && (0, _preact.h)("div", {
        className: "community-language-switcher_dropdown"
      }, isAdmin ? (0, _preact.h)("div", null, this.renderLanguageSwitcherDropdownGroup('Published languages', publishedLanguages, isPublishedLanguagesGroupOpen, function () {
        return _this2.setState({
          isPublishedLanguagesGroupOpen: !isPublishedLanguagesGroupOpen
        });
      }), this.renderLanguageSwitcherDropdownGroup('Unpublished languages', enabledLanguages, isUnpublishedLanguagesGroupOpen, function () {
        return _this2.setState({
          isUnpublishedLanguagesGroupOpen: !isUnpublishedLanguagesGroupOpen
        });
      })) : languageOptions.map(function (language) {
        return _this2.renderLanguageSwitcherDropdownItem(language);
      }))));
    }
  }]);
  return LanguageSwitcher;
}(_preact.Component);

exports.default = LanguageSwitcher;